export default __webpack_public_path__ + "static/corevitas-47e7049024ee275286b0e53e0545f5ee.png";